// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDAD4MiUOaG7nVZjU-uchM0R15DM-l4oRI",
  authDomain: "insyt-def61.firebaseapp.com",
  projectId: "insyt-def61",
  storageBucket: "insyt-def61.appspot.com",
  messagingSenderId: "394079957210",
  appId: "1:394079957210:web:e9a6e748e2e8beba7cf5e3",
  measurementId: "G-N6YPR9P2JM"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);